import {React, useState, useEffect, useCallback} from '@api'
import { ErrorComponent } from '@design-board/components'

interface MyProps {
  open?: boolean
  error?: any
}

export const ErrorContainer : React.FunctionComponent<MyProps> = (props) => {
  const [state, setState] = useState({
    open:         false,
    errorMessage: ''
  })

  useEffect(() => {
    if (props.error !== '' && !state.open) {
      setState({open: true, errorMessage: props.error})
    }
  }, [props.error])

  const handleClose = useCallback((event, reason) => {
    if (reason !== 'clickaway') {
      setState({...state, open: false})
    }
  }, [])

  return <ErrorComponent
    errorMessage={state.errorMessage}
    open={state.open}
    vertical='bottom'
    horizontal='right'
    handleClose={handleClose}
  />
}



// WEBPACK FOOTER //
// ./src/modules/errors/containers/Error.tsx